import { z } from "zod";

/**
 * Kundenliste und Notizen — geteilte Request-Shapes (FE + BE + MCP-Werkzeuge).
 * Reiner Umzug aus `customers.routes.ts`, Verhalten unverändert.
 */

/** Query für GET /customers (Query-Strings sind immer Text → Coercion hier). */
export const customerListQuerySchema = z.object({
  // Fastify parst wiederholte Query-Keys (?segmentId=a&segmentId=b) zu
  // einem Array. Wir akzeptieren beides und normalisieren auf string[].
  segmentId: z
    .union([z.string().uuid(), z.array(z.string().uuid())])
    .optional()
    .transform((v): string[] | undefined =>
      v === undefined ? undefined : Array.isArray(v) ? v : [v],
    ),
  q: z.string().optional(),
  // Alphabet-Filterleiste: erster Buchstabe des Namens (Prefix-Match).
  letter: z.string().length(1).optional(),
  withoutLead: z
    .enum(["true", "false"])
    .transform((v) => v === "true")
    .optional(),
  // BL-Review: Kunden mit Projekten ohne Beauftragungs-Zuordnung.
  withUnassignedProjects: z
    .enum(["true", "false"])
    .transform((v) => v === "true")
    .optional(),
  // Abgaenge mitzeigen — Kunden ohne laufendes Projekt.
  includeInactive: z
    .enum(["true", "false"])
    .transform((v) => v === "true")
    .optional(),
  page: z
    .string()
    .optional()
    .transform((v) => (v ? parseInt(v, 10) : 1))
    .pipe(z.number().int().min(1)),
  pageSize: z
    .string()
    .optional()
    .transform((v) => (v ? parseInt(v, 10) : 50))
    .pipe(z.number().int().min(1).max(200)),
});

/** Body für POST /customers/:id/notes. */
export const customerNoteCreateSchema = z.object({
  note: z.string().min(1).max(10000),
  segmentId: z.string().uuid(),
  crossSegment: z.boolean().default(false),
});

/** Body für PATCH /customers/:id/notes/:noteId. */
export const customerNoteUpdateSchema = z.object({
  note: z.string().min(1).max(10000),
});
